declare namespace $ {

	export class $bog_builderui_gallery extends $mol_view {
		items( ): readonly($mol_view)[]
		sub( ): ReturnType< $bog_builderui_gallery['items'] >
	}
	
}

//# sourceMappingURL=gallery.view.tree.d.ts.map